// extracted by mini-css-extract-plugin
export default {"headingBlock":"PDqLsteQWQpVVUVG4MZ4"};